module.exports = __webpack_public_path__ + "img/SV.59a21fa5.png";